import { render, staticRenderFns } from "./ubicacion.vue?vue&type=template&id=3993dbcb&scoped=true&"
import script from "./ubicacion.vue?vue&type=script&lang=ts&"
export * from "./ubicacion.vue?vue&type=script&lang=ts&"
import style0 from "./ubicacion.vue?vue&type=style&index=0&id=3993dbcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993dbcb",
  null
  
)

export default component.exports